import { Inject, Injectable, Injector } from '@angular/core';
import { find, isString } from 'lodash';
import { AbstractReplenishDataService } from './abstract-replenish-data.service';
import { ReplenishDataSource } from './replenish-data.enums';

/**
 * replenish data service provider, u can use this to get target replenish data service
 */
@Injectable()
class ReplenishDataServiceProvider {
  public constructor(
    public injector: Injector,
    @Inject('ReplenishDataServices') public services,
  ) {}

  public getServiceClass(
    predicate: ReplenishDataSource | Object,
  ): AbstractReplenishDataService {
    const findCriteria = isString(predicate)
      ? { SOURCE_NAME: predicate }
      : predicate;

    return find(this.services, findCriteria);
  }

  public getService(
    predicate: ReplenishDataSource | Object,
  ): AbstractReplenishDataService {
    const serviceClass = this.getServiceClass(predicate);
    const service = this.injector.get(serviceClass);

    return service;
  }
}

export { ReplenishDataServiceProvider };
